import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormControlErrorMessageModule } from '@portal-core/forms/components/form-control-error-message/form-control-error-message.module';
import { ErrorsExpansionPanelModule } from '@portal-core/general/components/errors-expansion-panel/errors-expansion-panel.module';
import { LoaderModule } from '@portal-core/general/components/loader/loader.module';
import { ProjectFilePathInputModule } from '@portal-core/project-files/components/project-file-path-input/project-file-path-input.module';
import { McColorModule } from '@portal-core/ui/themes/directives/mc-color.module';
import { CommitFileDialogComponent } from './commit-file-dialog.component';

@NgModule({
  declarations: [
    CommitFileDialogComponent
  ],
  imports: [
    McColorModule,
    CommonModule,
    ErrorsExpansionPanelModule,
    FormControlErrorMessageModule,
    FormsModule,
    LoaderModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatSnackBarModule,
    MatToolbarModule,
    MatTooltipModule,
    ProjectFilePathInputModule,
    ReactiveFormsModule
  ],
  exports: [
    CommitFileDialogComponent
  ]
})
export class CommitFileDialogModule { }
